import React from "react";
import { getImageUrl } from "@/utils/global";
import { FaFacebookF } from "react-icons/fa";
import { AiOutlineInstagram } from "react-icons/ai";
import { FaTiktok } from "react-icons/fa6";

interface Props {
    props: string;
}

const TopNav: React.FC<Props> = ({ props }) => {
    return (
        <>
            <div
                className={`top-nav md:h-[44px] h-[30px] border-b border-line ${props}`}
                style={{
                    backgroundImage: `url(${getImageUrl("/images/patrones/fondo%20test.png")})`,
                }}
            >
                <div className="container mx-auto h-full ">
                    <div className="top-nav-main flex justify-between items-center h-full max-md:justify-center">
                        <div className="left-content flex items-center">
                            <ul className="flex items-center gap-5 max-md:gap-4 max-md:overflow-x-auto max-md:scrollbar-hide max-md:whitespace-nowrap max-md:px-4 max-md:w-full max-md:justify-center">
                                <li className="max-md:flex-shrink-0">
                                    <a
                                        href="/contacto"
                                        className="caption2 hover:underline"
                                    >
                                        Contacto
                                    </a>
                                </li>
                                <li className="max-md:flex-shrink-0">
                                    <a
                                        href={`${window.origin}/ubicacion`}
                                        className="caption2 hover:underline"
                                    >
                                        Ubicación
                                    </a>
                                </li>
                                <li className="max-md:flex-shrink-0">
                                    <a
                                        href={`${window.origin}/nosotros`}
                                        className="caption2 hover:underline"
                                    >
                                        Nosotros
                                    </a>
                                </li>
                                <li className="max-md:flex-shrink-0">
                                    <a
                                        href={`${window.origin}/auth/register`}
                                        className="caption2 hover:underline"
                                    >
                                        Registrate
                                    </a>
                                </li>
                                <li className="max-md:flex-shrink-0">
                                    <a
                                        href={`${window.origin}/cotizacion/normal`}
                                        className="caption2 hover:underline"
                                    >
                                        Cotizaciones
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="right-content flex items-center gap-4 max-md:hidden">
                            <a
                                href="https://www.facebook.com/TortasPattyCarino/?locale=es_LA&checkpoint_src=any"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="hover:text-[#790546] transition-colors duration-200"
                            >
                                <FaFacebookF size={16} />
                            </a>
                            <a
                                href="https://www.instagram.com/tortaspattycarino/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="hover:text-[#790546] transition-colors duration-200"
                            >
                                <AiOutlineInstagram size={18} />
                            </a>
                            <a
                                href="https://www.tiktok.com/@pattypasteleria"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="hover:text-[#790546] transition-colors duration-200"
                            >
                                <FaTiktok size={16} />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TopNav;
